const fromdataedit = [
{
		inputdata: '',
		title: '产品代码',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '210px',
		disabled: false,
		lablewith: '90px',
		btx: true,
	},
	{
		inputdata: '',
		title: '存货名称',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '210px',
		lablewith: '90px',
		btx: true,

	},
	{
		inputdata: '',
		title: '产品线',
		fontSize: '14px',
		color: '#333333',
		placeholder: '全部',
		types: '',
		inputtype: 'select',
		width: '220px',
		btx: true,
		lablewith: '90px',
		options: [
		]
	},
	{
		inputdata: '',
		title: '计量单位',
		fontSize: '14px',
		color: '#333333',
		placeholder: '全部',
		types: '',
		inputtype: 'select',
		width: '220px',
		btx: true,
		lablewith: '90px',
		options: [
		]
	},
	{
		inputdata: '',
		title: '规格型号',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '210px',
		disabled: false,
		lablewith: '90px',
		btx: false,
	},
	{
		inputdata: '',
		title: '产品描述',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '210px',
		disabled: false,
		lablewith: '90px',
		btx: false,
	},
	{
		inputdata: '',
		title: '储运条件',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '210px',
		btx: true,
		lablewith: '90px',
	},
	{
		inputdata: '',
		title: '注册证号',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '210px',
		disabled: false,
		lablewith: '90px',
		btx: false,
	},
	{
		inputdata: '',
		title: '生产许可证',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '210px',
		disabled: false,
		lablewith: '90px',
		btx: false,
	},
	{
		inputdata: '',
		title: '全国ABC分类',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '210px',
		disabled: false,
		lablewith: '90px',
		btx: false,
	},
	{
		inputdata: '',
		title: '属否批量管理',
		fontSize: '14px',
		color: '#333333',
		placeholder: '',
		types: 'text',
		inputtype: 'radio',
		width: "210px",
		radiotitle1: "是",
		radiotitle2: "否",
		lablewith: '90px'
	},
	{
		inputdata: '',
		title: '是否效期管理',
		fontSize: '14px',
		color: '#333333',
		placeholder: '',
		types: 'text',
		inputtype: 'radio',
		width: "210px",
		radiotitle1: "是",
		radiotitle2: "否",
		lablewith: '100px'
	},
	{
		inputdata: "1",
		title: "参考成本",
		fontSize: "14px",
		color: "#333333",
		placeholder: "",
		types: "",
		inputtype: "numbertows",
		width: "220px",
		minleft: 0,
		maxleft: undefined,
		lablewith: '90px'
	},
	{
		inputdata: "1",
		title: "参考售价",
		fontSize: "14px",
		color: "#333333",
		placeholder: "",
		types: "",
		inputtype: "numbertows",
		width: "220px",
		minleft: 0,
		maxleft: undefined,
		lablewith: '90px'
	},
	{
		inputdata: '',
		title: '是否启用',
		fontSize: '14px',
		color: '#333333',
		placeholder: '',
		types: 'text',
		inputtype: 'radio',
		width: "210px",
		radiotitle1: "是",
		radiotitle2: "否",
		lablewith: '90px'
	},
	{
		inputdata: '',
		title: '标准货值',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '210px',
		disabled: false,
		lablewith: '90px',
		btx: false,
	},
	{
		inputdata: '',
		title: 'LEVEL1',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '210px',
		disabled: false,
		lablewith: '90px',
		btx: false,
	},
	{
		inputdata: '',
		title: 'LEVEL2',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '210px',
		disabled: false,
		lablewith: '90px',
		btx: false,
	},
	{
		inputdata: '',
		title: 'LEVEL3',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '210px',
		disabled: false,
		lablewith: '90px',
		btx: false,
	},
	{
		inputdata: '',
		title: 'LEVEL4',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '210px',
		disabled: false,
		lablewith: '90px',
		btx: false,
	},{
    inputdata: "",
    title: "LEVEL1.5",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "210px",
    disabled: false,
    lablewith: "90px",
    btx: false,
  },
	{
    inputdata: "",
    title: "生产厂商",
    fontSize: "14px",
    color: "#333333",
    placeholder: "全部",
    types: "",
    inputtype: "select",
    width: "220px",
    btx: false,
    lablewith: "90px",
    options: [
    ],
  },

	]
export default fromdataedit;
